import React from 'react';

interface StoryDetailProps {
  title: string;
  author: string;
  cover: string;
  reads: string;
  description: string;
  genre: string;
  onBack?: () => void;
}

const StoryDetail: React.FC<StoryDetailProps> = ({
  title,
  author,
  cover,
  reads,
  description,
  genre,
  onBack
}) => {
  return (
    <div
      style={{
        background: '#f9f9f9',
        minHeight: '100vh',
        padding: '40px',
        fontFamily: "'Inter', sans-serif"
      }}
    >
      {/* Back Button */}
      <button
        onClick={onBack}
        style={{
          background: 'none',
          border: 'none',
          color: '#4ECDC4',
          fontSize: '1rem',
          fontWeight: '600',
          marginBottom: '20px',
          cursor: 'pointer'
        }}
      >
        ← Back to Stories
      </button>

      {/* Story Header */}
      <div
        style={{
          display: 'flex',
          gap: '30px',
          background: 'white',
          padding: '30px',
          borderRadius: '16px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
          maxWidth: '900px',
          margin: '0 auto'
        }}
      >
        <div
          style={{
            fontSize: '6rem',
            background: 'linear-gradient(135deg, #4ECDC4, #44A08D)',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '140px',
            minHeight: '140px',
            color: 'white'
          }}
        >
          {cover}
        </div>
        <div>
          <h1 style={{ fontSize: '2.2rem', fontWeight: '800', color: '#1a3a52' }}>{title}</h1>
          <p style={{ color: '#666', fontWeight: '500', marginBottom: '8px' }}>by {author}</p>
          <p style={{ fontSize: '0.9rem', color: '#4ECDC4', marginBottom: '12px' }}>{genre}</p>
          <div
            style={{
              background: '#f1f1f1',
              display: 'inline-block',
              padding: '6px 14px',
              borderRadius: '20px',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: '#666'
            }}
          >
            {reads} reads
          </div>
        </div>
      </div>

      {/* Story Description */}
      <div
        style={{
          background: 'white',
          padding: '30px',
          borderRadius: '16px',
          margin: '30px auto',
          maxWidth: '900px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
          lineHeight: '1.6'
        }}
      >
        <h2 style={{ fontSize: '1.4rem', fontWeight: '700', marginBottom: '15px', color: '#1a3a52' }}>
          Story Summary
        </h2>
        <p style={{ fontSize: '1rem', color: '#555' }}>{description}</p>
      </div>

      {/* Comments Section */}
      <div
        style={{
          background: 'white',
          padding: '30px',
          borderRadius: '16px',
          margin: '30px auto',
          maxWidth: '900px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
        }}
      >
        <h2 style={{ fontSize: '1.4rem', fontWeight: '700', marginBottom: '15px', color: '#1a3a52' }}>
          Comments
        </h2>
        <div style={{ marginBottom: '15px', color: '#666' }}>💬 No comments yet. Be the first!</div>
        <textarea
          placeholder="Write your comment..."
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid #ddd',
            fontSize: '1rem',
            marginBottom: '12px'
          }}
        />
        <button
          style={{
            background: '#4ECDC4',
            color: 'white',
            padding: '12px 25px',
            borderRadius: '10px',
            border: 'none',
            fontWeight: '700',
            cursor: 'pointer'
          }}
        >
          Post Comment
        </button>
      </div>
    </div>
  );
};

export default StoryDetail;